import { camelCase } from 'lodash';

export class ActiveVehicle {
  id: number = null;
  unitSerialNumber: string = null;
  regoNumber: string = null;
  driver: string = null;
  clientReference: string = null;
  icon: string = null;
  costCentre: number = null;
  costCentreName: string = null;
  startOdo: number = null;
  kmSinceStart: number = null;
  obdOdometer: number = null;
  expires: Date = null;
  lastMoved: Date = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
